import { DatePipe, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RestrictedNavigationService } from '@services/restricted-navigation.service';

@Component({
  selector: 'app-stdcheck-layout',
  templateUrl: './stdcheck-layout.component.html',
  styleUrls: ['./stdcheck-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, DatePipe, NgOptimizedImage],
})
export class StdcheckLayoutComponent implements OnInit {
  public today: Date = new Date();
  public restrictedNavigation: boolean = false;

  protected restrictedNavigationService = inject(RestrictedNavigationService);

  public ngOnInit(): void {
    this.restrictedNavigationService.restrictedNavigationObserver.subscribe((r) => (this.restrictedNavigation = r));
  }
}
